/** Split CSV text into trimmed cell rows using the given delimiter. */
export function parseRows(text: string, delimiter: string): string[][] {
  return text
    .split('\n')
    .filter(row => row.trim())
    .map(row => row.split(delimiter).map(col => col.trim()));
}
